import type {
    CommerceStorefrontContact,
    CommerceStorefrontExperience,
} from "@teqtank/commerce-contracts";
import { MockCommerceTransport } from "@teqtank/commerce-transport";
import { resolveCommerceStorefrontOperation } from "../operations/resolve-commerce-storefront-operation.js";
import { clearCommerceStorefrontOperation } from "../operations/clear-commerce-storefront-operation.js";
export function registerDefaultStorefrontOperations(transport: MockCommerceTransport): void {
    let current: CommerceStorefrontExperience | null = null;
    transport.register(resolveCommerceStorefrontOperation, (request) => {
        const parsed = request.url ? new URL(request.url, "https://shop.example.test") : null;
        const alias = request.webAlias ?? current?.attribution.webAlias;
        if (!alias) {
            current = generic();
            return { storefront: current };
        }
        const contact: CommerceStorefrontContact = {
            id: request.referrerId ?? `contact:${alias}`,
            webAlias: alias,
            displayName:
                alias === "alexrivera"
                    ? "Alex Rivera"
                    : alias.replace(/[-_]/g, " ").replace(/\b\w/g, (v) => v.toUpperCase()),
            role: "Independent Brand Partner",
            biography: "Here to help you find the products and routines that fit your goals.",
            avatar: null,
            location: {
                city: "Auckland",
                region: "Auckland",
                countryCode: "NZ",
                display: "Auckland, New Zealand",
            },
            methods: {
                email: `${alias}@example.test`,
                phone: "+64 21 555 0147",
                websiteUrl: `https://shop.example.test/${alias}`,
                messageUrl: `sms:+64215550147`,
                vCardUrl: `https://shop.example.test/${alias}/contact.vcf`,
            },
        };
        current = {
            status: "resolved",
            contact,
            attribution: {
                referrerId: contact.id,
                webAlias: alias,
                campaign: request.campaign ?? parsed?.searchParams.get("campaign") ?? null,
                referrer: request.referrer ?? null,
                landingPage: request.url ?? null,
            },
            requestedAlias: alias,
            notice: null,
            marketId: "new-zealand",
            currencyCode: "NZD",
            languageCode: "en",
            resolvedAt: new Date(),
        };
        return { storefront: current };
    });
    transport.register(clearCommerceStorefrontOperation, () => {
        current = generic();
        return { storefront: current };
    });
}

function generic(): CommerceStorefrontExperience {
    return {
        status: "generic",
        contact: null,
        attribution: {
            referrerId: null,
            webAlias: null,
            campaign: null,
            referrer: null,
            landingPage: null,
        },
        requestedAlias: null,
        notice: null,
        marketId: "new-zealand",
        currencyCode: "NZD",
        languageCode: "en",
        resolvedAt: new Date(),
    };
}
